import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { useRouter } from "next/router";
import { storyblokEditable } from "@storyblok/react";
import classNames from "classnames";
import { useCurrentUser } from "@hooks/use-current-user";
import Button from "@components/core/Button";
import Badge from "@components/core/Badge";
import Link from "@components/core/Link";

function NavsearchLink({ blok, parentTitle }) {
  const router = useRouter();
  const user = useCurrentUser();
  const userGroup = user?.user_group || "visitor";

  function sendLinkTrackerData() {
    const defaultEventData = {
      tracking_name: "navsearchLink",
      parent_title: parentTitle || "",
      page: router.asPath,
      link: blok.link.url,
      link_title: blok.title,
      user_group: userGroup,
    };

    ahoy("$click", defaultEventData);
    analytics.track("$click", defaultEventData);
  }

  function handleClick() {
    sendLinkTrackerData();
  }

  if (!blok) return null;

  return (
    <div
      key={blok._uid}
      {...storyblokEditable(blok)}
      className={classNames(blok.container_with_bottom_spacing && "container-with-bottom-spacing")}
    >
      <Link
        href={blok.link?.url}
        onClick={handleClick}
      >
        <Button
          key={blok._uid}
          title={blok.title}
          variant={blok.link_class}
          className="no-underline navsearch-link-btn bg-white navsearch-btn short-padding"
          spaceBetween
          fullWidth
          userGroup={userGroup}
        >
          <div className="navsearch-link-content">
            <p className="mb-0 text-1-line">{blok.title}</p>
            {blok.with_badge && (
              <Badge
                variant={blok.badge_variant || "light-primary"}
                iconName={blok.badge_icon}
                className="ms-2"
              >
                {blok.badge_text || "Ajouter votre texte"}
              </Badge>
            )}
          </div>
        </Button>
      </Link>
    </div>
  );
}

export default NavsearchLink;
